<template>
    <div class="addBox relative">
        <div class="title">
            <div class="title_left"><span class="movePoin" @click="$router.go(-1)">晨检 </span> / <span
                    class="type">新增</span></div>
        </div>
        <el-form label-width="150px">
            <ToggleForm title="基本信息">
                <div class="content">
                    <div class="row mt20">
                        <el-form-item label="被检查人：">
                            <el-button plain class="addBtn"><span>{{inspectedName.join()}}</span></el-button>
                        </el-form-item>
                    </div>
                    <div class="row">
                        <el-form-item label="检查时间：">
                            <el-date-picker
                                    style="width: 300px"
                                    v-model="addInspect.checkTime"
                                    type="date"
                                    placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="row">
                        <el-form-item label="检查人：">
                            <el-select v-model="addInspect.checker" multiple collapse-tags placeholder="请选择检查人" style="width: 300px;">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
            </ToggleForm>
            <ToggleForm title="晨检明细表">
                <div class="content">
                    <el-alert
                            title="请选择问题项, 未选择的的默认为合格"
                            type="warning"
                            show-icon
                            style="margin-bottom: 20px"
                    >
                    </el-alert>
                    <div class="tabOffTop120">
                        <!-- v-loading="loading" element-loading-text="数据正在努力加载中"  -->
                        <el-table ref="multipleTable" :data="inspectedPr" tooltip-effect="dark"
                                  style="width: 100%"  @current-change="toggleRowExpansion">
                            <el-table-column label="被检查人" width="80" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row.empName}}</template>
                            </el-table-column>
                            <el-table-column prop="empPost" label="职务" width="80" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column label="发热">
                                <template slot-scope="scope">
                                    <img src="../../assets/img/checkbox.png" v-if="!scope.row.problemItemCode.includes('0001')"  @click="selectData(scope.$index,scope.row,'0001')" class="checkBtn">
                                    <img src="../../assets/img/checkedbox.png" v-if="scope.row.problemItemCode.includes('0001')" @click="selectData(scope.$index,scope.row, '0001')" class="checkBtn">
                                </template>
                            </el-table-column>
                            <el-table-column label="感冒咳嗽">
                                <template slot-scope="scope">
                                    <img src="../../assets/img/checkbox.png" v-if="!scope.row.problemItemCode.includes('0002')" @click="selectData(scope.$index,scope.row, '0002')" class="checkBtn">
                                    <img src="../../assets/img/checkedbox.png" v-if="scope.row.problemItemCode.includes('0002')" @click="selectData(scope.$index,scope.row, '0002')" class="checkBtn">
                                </template>
                            </el-table-column>
                            <el-table-column label="外伤">
                                <template slot-scope="scope">
                                    <img src="../../assets/img/checkbox.png" v-if="!scope.row.problemItemCode.includes('0003')"  @click="selectData(scope.$index,scope.row, '0003')" class="checkBtn">
                                    <img src="../../assets/img/checkedbox.png" v-if="scope.row.problemItemCode.includes('0003')" @click="selectData(scope.$index,scope.row, '0003')" class="checkBtn">
                                </template>
                            </el-table-column>
                            <el-table-column label="呕吐腹泻">
                                <template slot-scope="scope">
                                    <img src="../../assets/img/checkbox.png" v-if="!scope.row.problemItemCode.includes('0004')" @click="selectData(scope.$index,scope.row, '0004')" class="checkBtn">
                                    <img src="../../assets/img/checkedbox.png" v-if="scope.row.problemItemCode.includes('0004')" @click="selectData(scope.$index,scope.row, '0004')" class="checkBtn">
                                </template>
                            </el-table-column>
                            <el-table-column label="皮肤疾病">
                                <template slot-scope="scope">
                                    <img src="../../assets/img/checkbox.png" v-if="!scope.row.problemItemCode.includes('0005')"  @click="selectData(scope.$index,scope.row, '0005')" class="checkBtn">
                                    <img src="../../assets/img/checkedbox.png" v-if="scope.row.problemItemCode.includes('0005')" @click="selectData(scope.$index,scope.row, '0005')" class="checkBtn">
                                </template>
                            </el-table-column>
                            <el-table-column label="其它疾病">
                                <template slot-scope="scope">
                                    <img src="../../assets/img/checkbox.png" v-if="!scope.row.problemItemCode.includes('5000')"  @click="selectData(scope.$index,scope.row, '5000')" class="checkBtn">
                                    <img src="../../assets/img/checkedbox.png" v-if="scope.row.problemItemCode.includes('5000')" @click="selectData(scope.$index,scope.row, '5000')" class="checkBtn">
                                </template>
                            </el-table-column>
                            <el-table-column label="着装不规范">
                                <template slot-scope="scope">
                                    <img src="../../assets/img/checkbox.png" v-if="!scope.row.problemItemCode.includes('5001')"  @click="selectData(scope.$index,scope.row, '5001')" class="checkBtn">
                                    <img src="../../assets/img/checkedbox.png" v-if="scope.row.problemItemCode.includes('5001')" @click="selectData(scope.$index,scope.row, '5001')" class="checkBtn">
                                </template>
                            </el-table-column>
                            <el-table-column label="双手不干净">
                                <template slot-scope="scope">
                                    <img src="../../assets/img/checkbox.png" v-if="!scope.row.problemItemCode.includes('5002')" @click="selectData(scope.$index,scope.row, '5002')" class="checkBtn">
                                    <img src="../../assets/img/checkedbox.png" v-if="scope.row.problemItemCode.includes('5002')" @click="selectData(scope.$index,scope.row, '5002')" class="checkBtn">
                                </template>
                            </el-table-column>
                            <el-table-column label="指甲过长">
                                <template slot-scope="scope">
                                    <img src="../../assets/img/checkbox.png" v-if="!scope.row.problemItemCode.includes('5003')"  @click="selectData(scope.$index,scope.row, '5003')" class="checkBtn">
                                    <img src="../../assets/img/checkedbox.png" v-if="scope.row.problemItemCode.includes('5003')" @click="selectData(scope.$index,scope.row, '5003')" class="checkBtn">
                                </template>
                            </el-table-column>
                            <el-table-column label="戒指等饰品">
                                <template slot-scope="scope">
                                    <img src="../../assets/img/checkbox.png" v-if="!scope.row.problemItemCode.includes('5004')"  @click="selectData(scope.$index,scope.row, '5004')" class="checkBtn">
                                    <img src="../../assets/img/checkedbox.png" v-if="scope.row.problemItemCode.includes('5004')" @click="selectData(scope.$index,scope.row, '5004')" class="checkBtn">
                                </template>
                            </el-table-column>
                            <el-table-column label="其它卫生问题" width="120">
                                <template slot-scope="scope">
                                    <img src="../../assets/img/checkbox.png" v-if="!scope.row.problemItemCode.includes('9999')"  @click="selectData(scope.$index,scope.row, '9999')" class="checkBtn">
                                    <img src="../../assets/img/checkedbox.png" v-if="scope.row.problemItemCode.includes('9999')" @click="selectData(scope.$index,scope.row, '9999')" class="checkBtn">
                                </template>
                            </el-table-column>
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                    <el-table :data="props.row.problem" tooltip-effect="dark" style="width: 100%">
                                        <el-table-column label="序号" width="180">
                                            <template slot-scope="scope">{{ scope.row.date }}</template>
                                        </el-table-column>
                                        <el-table-column prop="name" label="问题" show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column prop="address" label="处理结果" show-overflow-tooltip>
                                        </el-table-column>
                                    </el-table>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </ToggleForm>
            <ToggleForm title="图片附件">
                <div class="content">
                    <div class="row rowybUpload">
                        <el-form-item label="健康证：">
                            <p class="rowybUploadText w400">上传图片大小不超过10M；上传格式：jpg、png、gif，只能上传5张图片。</p>
                            <ybUpload :maxLength=5 @uploadSuccess='getFiles' @uploadError="getFiles"
                                      @remove='getFiles' :filesArr='filesArr'></ybUpload>
                            <!-- filesArr:[],回显的时候必传 -->
                        </el-form-item>
                    </div>
                    <div class="row mt20">
                        <el-form-item label="备注：" prop="remark" class="clear_a">
                            <el-input
                                    style="width: 300px;"
                                    :autosize="{minRows:6}"
                                    type="textarea"
                                    placeholder="请输入备注, 不超过300字"
                                    v-model="addInspect.remark"
                                    maxlength="300"
                                    show-word-limit>
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
            </ToggleForm>
        </el-form>
        <div class="foot-btn">
            <div>
                <el-button class="w70 mr10" @click="$router.go(-1)">取消</el-button>
                <el-button type="primary w70 ">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import * as storage from '../../utils/sessionStorage'
    import ToggleForm from "components/ToggleForm";
    import ybUpload from "components/ybUpload";

    export default {
        name: "inspectAdd",
        components: {ToggleForm, ybUpload},
        data() {
            return {
                inspectedPr: [],
                addInspect: {
                    checker: '',
                    checkTime: '',
                    inspected: '',
                    remark: ''
                },
                options: [{
                    value: '选项1',
                    label: '黄金糕'
                }, {
                    value: '选项2',
                    label: '双皮奶'
                }, {
                    value: '选项3',
                    label: '蚵仔煎'
                }, {
                    value: '选项4',
                    label: '龙须面'
                }, {
                    value: '选项5',
                    label: '北京烤鸭'
                }],
                filesArr: [],
                inspectedName: [],
            }
        },

        methods: {
            getInspectedPr() {
                this.inspectedPr = JSON.parse(storage.getData('inspectedPerson'))
                this.inspectedPr.map(item => {
                    item.problemItemCode = [];
                    this.inspectedName.push(item.empName)
                })
            },
            getFiles(Files, state) {
                console.log(Files, state)
            },
            selectData(index,data, num){
                if(!data.problemItemCode.includes(num)){
                    let newValue = Object.assign(this.inspectedPr[index], this.inspectedPr[index].problemItemCode.push(num))
                    this.$set(this.inspectedPr,index, newValue)
                }else if(data.problemItemCode.includes(num)){
                    for(let i in data.problemItemCode){
                        if (data.problemItemCode[i] === num) {
                            data.problemItemCode.splice(i, 1);
                        }
                    }
                    this.$set(this.inspectedPr, index, data)
                }
            },
            toggleRowExpansion(row){
                // console.log(row)
            }
        },
        mounted() {
            this.getInspectedPr()
        }
    }
</script>

<style scoped lang="scss">
    .addBox {
        width: calc(100% - 40px);
        min-height: 100%;
        padding: 0 20px 100px 20px;
        .title {
            height: 60px;
            line-height: 60px;
            .title_left {
                font-size: 20px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                width: 50%;
                height: 100%;
                .type {
                    color: #70CE97;
                }
            }
        }
        .addBtn {
            width: 300px;
            text-align: left;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
        .content{
            padding: 30px;
        }
        .checkBtn{
            width: 16px;
            height: 16px;
        }
    }


</style>